import { render, staticRenderFns } from "./TemplateMeetingRoom.vue?vue&type=template&id=62b19a0e&scoped=true&"
import script from "./TemplateMeetingRoom.vue?vue&type=script&lang=js&"
export * from "./TemplateMeetingRoom.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMeetingRoom.vue?vue&type=style&index=0&id=62b19a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b19a0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
